import { render } from "./ItemWiring.vue?vue&type=template&id=821e2c2a&scoped=true"
import script from "./ItemWiring.vue?vue&type=script&lang=js"
export * from "./ItemWiring.vue?vue&type=script&lang=js"

import "./ItemWiring.vue?vue&type=style&index=0&id=821e2c2a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821e2c2a"]])

export default __exports__